import utility from './utility';
import timer from './timer';

const accountEntries = {
    selectedElement: null,
    monthsContainer: null,
    leftButton: null,
    rightButton: null,

    init: function () {
        accountEntries.selectEntry();

        const sortPendingEntriesSelector = document.querySelector("#account--entries-sort");
        if (sortPendingEntriesSelector) {
            sortPendingEntriesSelector.onchange = () => {
                accountEntries.loadEntries();
            };
        }

        const datecontainer = document.querySelector(".date-container");
        if (datecontainer) {
            accountEntries.rightButton = datecontainer.querySelector("#right");
            accountEntries.leftButton = datecontainer.querySelector("#left");
            accountEntries.monthsContainer = datecontainer.querySelector("#months");
            accountEntries.setEntriesMonth(accountEntries.monthsContainer.querySelector(".selected"), false);
            
            accountEntries.rightButton.onclick = (e) => {
                e.preventDefault();
                const nextElement = accountEntries.selectedElement.nextElementSibling;
                if (nextElement) {
                    accountEntries.setEntriesMonth(nextElement, true);
                }
            }

            accountEntries.leftButton.onclick = (e) => {
                e.preventDefault();
                const previousElement = accountEntries.selectedElement.previousElementSibling;
                if (previousElement) {
                    accountEntries.setEntriesMonth(previousElement, true);
                }
            }
        }

        const accountEntriesList = document.querySelector("#account--entries-list");
        if (accountEntriesList) {
            [...accountEntriesList.querySelectorAll(".info-icon")].map(el => {
                el.onclick = () => {
                    const data = el.parentElement.nextElementSibling;
                    if (data) {
                        if (data.classList.contains("active")) {
                            data.style.maxHeight = 0;
                        } 
                        else {
                            data.style.maxHeight = `${data.scrollHeight}px`;
                        }
                        utility.toggleClass(data, "active");
                    }
                };
            });
        }
        
        const playAgainPopup = document.getElementById("global--play-again-popup");
        if (playAgainPopup) {
            playAgainPopup.querySelector(".replay-same").onclick = (el) => {
                accountEntries.playEntry(el.currentTarget);
            };
            playAgainPopup.querySelector(".replay-new").onclick = (el) => {
                accountEntries.playEntry(el.currentTarget);
            };
        }

        if (accountEntriesList) {
            accountEntries.bindPlayAgainButtons(accountEntriesList);
            accountEntries.formatJokerMatches(accountEntriesList);
        }
        accountEntries.futureDraw();
    },

    selectEntry: function() {
        try {
            if (!window.URLSearchParams) {
                return;
            }
            const urlEntryId = new window.URLSearchParams(window.location.search).get('entry');
            if (!urlEntryId) {
                return;
            }
            let selectedEntry = document.querySelector(`#${urlEntryId}`);
            if (selectedEntry.dataset.itemtype === "SYN") {
                selectedEntry = utility.findAncestor(selectedEntry, "lottery-card");
            }
            if (selectedEntry) {
                window.scrollBy({ top: selectedEntry.offsetTop, left: 0, behavior: "smooth" });
                accountEntries.showEntryDetail(selectedEntry);
            }
        }
        catch (error) {
            return;
        }
    },

    getPreviousElementCount: function (element) {
        let count = 0;
        while ((element = element.previousElementSibling)) {
            count++;
        }
        return count;
    },

    getNextElementCount: function (element) {
        let count = 0;
        while ((element = element.nextElementSibling)) {
            count++;
        }
        return count;
    },

    setEntriesMonth: function (element, loadEntries, filter) {  

        if (filter) {
            const futuredrawmonth = accountEntries.monthsContainer.querySelector(`[data-date="${element.dataset.date}"]`);
            utility.addClass(futuredrawmonth, "selected");
            accountEntries.selectedElement = futuredrawmonth;

        } else {
            accountEntries.selectedElement = element;   
        }


        const width = filter ? 76 : accountEntries.selectedElement.offsetWidth;
        const previousElements = accountEntries.getPreviousElementCount(accountEntries.selectedElement);
        const nextElements = accountEntries.getNextElementCount(accountEntries.selectedElement);
        accountEntries.monthsContainer.scrollLeft = previousElements * width;
        if (previousElements === 0) {
            accountEntries.leftButton.classList.add("hide");
        }
        else {
            accountEntries.leftButton.classList.remove("hide");
        }
        if (nextElements === 0) {
            accountEntries.rightButton.classList.add("hide");
        }
        else {
            accountEntries.rightButton.classList.remove("hide");
        }
        if (loadEntries) {
            accountEntries.loadEntries();
        }
    },

    formatJokerMatches: function (container) {
        [...container.querySelectorAll(".joker-number")].map(el => {
            const winningjoker = el.dataset.winningjoker;

            if (winningjoker) {
                let jokerString = el.innerHTML;
                if (jokerString === winningjoker) {
                    el.innerHTML = `<mark>${jokerString}</mark>`
                }
                else {
                    var firstPart = "";
                    var endPart = "";

                    // match start
                    if (jokerString.startsWith(winningjoker.substring(0, 6), 0)) {
                        firstPart = jokerString.substring(0, 6);
                    }
                    else if (jokerString.startsWith(winningjoker.substring(0, 5), 0)) {
                        firstPart = jokerString.substring(0, 5);
                    }
                    else if (jokerString.startsWith(winningjoker.substring(0, 4), 0)) {
                        firstPart = jokerString.substring(0, 4);
                    }
                    else if (jokerString.startsWith(winningjoker.substring(0, 3), 0)) {
                        firstPart = jokerString.substring(0, 3);
                    }
                    else if (jokerString.startsWith(winningjoker.substring(0, 2), 0)) {
                        firstPart = jokerString.substring(0, 2);
                    }
                    else if (jokerString.startsWith(winningjoker.substring(0, 1), 0)) {
                        firstPart = jokerString.substring(0, 1);
                    }

                    // match end
                    if (jokerString.endsWith(winningjoker.substring(7, 1))) {
                        endPart = jokerString.substring(7, 1);
                    }
                    else if (jokerString.endsWith(winningjoker.substring(7, 2))) {
                        endPart = jokerString.substring(7, 2);
                    }
                    else if (jokerString.endsWith(winningjoker.substring(7, 3))) {
                        endPart = jokerString.substring(7, 3);
                    }
                    else if (jokerString.endsWith(winningjoker.substring(7, 4))) {
                        endPart = jokerString.substring(7, 4);
                    }
                    else if (jokerString.endsWith(winningjoker.substring(7, 5))) {
                        endPart = jokerString.substring(7, 5);
                    }
                    else if (jokerString.endsWith(winningjoker.substring(7, 6))) {
                        endPart = jokerString.substring(7, 6);
                    }

                    var middlePart = jokerString.substring(firstPart.length, 7 - endPart.length);
                    var formattedJoker = "";
                    if (firstPart.length > 0) {
                        formattedJoker = `<mark>${firstPart}</mark>`;
                    }
                    formattedJoker += middlePart;
                    if (endPart.length > 0) {
                        formattedJoker += `<mark>${endPart}</mark`;
                    }
                    el.innerHTML = formattedJoker;
                }
            }
        });
    },

    bindPlayAgainButtons: function(container) {
        const playAgainButtons = container.querySelectorAll(".play-again-btn");
        if (playAgainButtons) {
            [...playAgainButtons].map(el => {
                el.onclick = (e) => {
                    if (e.currentTarget.dataset.type === "SYN") {
                        accountEntries.playSyndicate(e.currentTarget);
                    } else {
                        const popupContainer = document.getElementById("global--play-again-popup");
                        popupContainer.querySelector(".replay-same").setAttribute("data-action", el.dataset.playsameurl);
                        popupContainer.querySelector(".replay-new").setAttribute("data-action", el.dataset.playrandurl);
                        utility.showPopup(popupContainer);
                    }
                };
            });
        }
    },
    
    playEntry: function(btn) {
        utility.disableButton(btn);
        const ajaxOptions = {
            url: btn.dataset.action,
            method: "POST",
            success: function (e) {
                const result = JSON.parse(e.target.responseText);
                if (result.success) {
                    const checkoutUrl = "/checkout";
                    if (result.info) {
                        utility.showNotificationPopup({
                            content: result.info,
                            button: {
                                url: checkoutUrl
                            },
                            hideCloseIcon: true,
                            title: ""
                        });
                    }
                    else {
                        window.location.href = checkoutUrl;
                    }                    
                }
                else {
                    const errorMessage = result.error ? result.error : "An unknown error occurred.";
                    utility.showNotificationPopup({
                        title: "Error",
                        content: errorMessage
                    });
                }
            },
            always: function(e) {
                utility.enableButton(btn);
            }
        }
        utility.ajaxRequest(ajaxOptions);
    },

    playSyndicate: function(btn) {
        utility.disableButton(btn);
        const ajaxOptions = {
            url: btn.dataset.playurl,
            method: "POST",
            success: function (e) {
                const result = JSON.parse(e.target.responseText);
                if (result.success) {
                    window.location.href = "/checkout";
                }
                else {
                    var button = null;
                    if (result.playnowurl) {
                        button = {
                            url: result.playnowurl,
                            text: "Play now"
                        };
                    }
                    utility.showNotificationPopup({
                        content: result.message,
                        button: button
                    });
                }
            },
            always: function(e) {
                utility.enableButton(btn);
            }
        }
        utility.ajaxRequest(ajaxOptions);
    },

    futureDraw: function () {
        const container = document.querySelector("#lottery-card-no-result-top");
        if (container) {
            [...container.querySelectorAll(".next-month")].map(nextmonth => {
                nextmonth.onclick = (e) => {
                    accountEntries.setEntriesMonth(nextmonth, true, true);
                }
            });
        }
    },

    loadEntries: function () {
        const fetchdate =  accountEntries.selectedElement.dataset.date;
        const sorting = document.querySelector("#account--entries-sort").value;
        const ajaxOptions = {
            url: "/api/web/account/get-entries",
            method: "POST",
            data: "date=" + fetchdate + "&sorting=" + sorting,
            success: function(e) {
                const container = document.querySelector("#account--entries-list");
                container.innerHTML = e.target.responseText;
                accountEntries.bindPlayAgainButtons(container);
                accountEntries.formatJokerMatches(container);
                accountEntries.showEntryDetails(container);
                if (container.innerHTML.includes("lottery-card-no-result")) {
                    accountEntries.futureDraw();
                    timer.init();
                }
            }
        };
        utility.ajaxRequest(ajaxOptions);

        
    },

    showEntryDetails: function (container) {        
        [...container.querySelectorAll(".results-expand")].map(el => {
            const details = el.previousElementSibling;
            const expandText = el.innerHTML;
            const expandLessText = el.dataset.subtext;            
            if (details && details.classList.contains("results-content")) {
                el.onclick = () => {
                    utility.toggleClass(el, "active");
                    if (el.classList.contains('active')) {
                        details.style.maxHeight = `${details.scrollHeight}px`;

                        //For system entry double sliders
                        const parentResultsContainer = utility.findAncestor(el, "results-content")
                        if (parentResultsContainer) {
                            const parentResultsContainerHeight = details.scrollHeight + parentResultsContainer.scrollHeight
                            details.classList.add("system-scroll")
                            parentResultsContainer.style.maxHeight = `${parentResultsContainerHeight}px`
                         }
                    } 
                    else {
                        details.style.maxHeight = 0;
                    }

                    if (expandLessText) {
                        if (!el.classList.contains('active')) {
                            el.querySelector('span').innerHTML = expandText;
                        } 
                        else {
                            el.querySelector('span').innerHTML = expandLessText;
                        }
                    }
                };
            }
        });
    },

    showEntryDetail: function (container) {
        [...container.querySelectorAll(".results-expand")].map(el => {
            const details = el.previousElementSibling;
            const expandText = el.innerHTML;
            const expandLessText = el.dataset.subtext;
            if (details.classList.contains("results-content")) {
                utility.toggleClass(el, "active");
                if (el.classList.contains('active')) {
                    details.style.maxHeight = `${details.scrollHeight}px`;

                    //For system entry double sliders
                    const parentResultsContainer = utility.findAncestor(el, "results-content")
                    if (parentResultsContainer) {
                        const parentResultsContainerHeight = details.scrollHeight + parentResultsContainer.scrollHeight
                        details.classList.add("system-scroll")
                        parentResultsContainer.style.maxHeight = `${parentResultsContainerHeight}px`;
                        parentResultsContainer.style.display = 'none';
                        parentResultsContainer.offsetHeight;  // Trigger reflow
                        parentResultsContainer.style.display = '';
                    }
                }
                else {
                    details.style.maxHeight = 0;
                }

                if (expandLessText) {
                    if (!el.classList.contains('active')) {
                        el.querySelector('span').innerHTML = expandText;
                    }
                    else {
                        el.querySelector('span').innerHTML = expandLessText;
                    }
                }               
            }
        });
    },      
};

export default accountEntries;


// WEBPACK FOOTER //
// ./assets/src/js/classes/accountEntries.js